export const CompactModeSettingDescriptor = {
    key: "CompactMode",
    defaultValue: !matchMedia("(pointer: coarse)").matches,
};
export const DisableCopySettingDescriptor = {
    key: "DisableCopy",
    defaultValue: false,
};
//# sourceMappingURL=globalSettings.js.map